import { render, staticRenderFns } from "./BlogContent.vue?vue&type=template&id=04b74214"
import script from "./BlogContent.vue?vue&type=script&lang=js"
export * from "./BlogContent.vue?vue&type=script&lang=js"
import style0 from "./BlogContent.vue?vue&type=style&index=0&id=04b74214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_-872774970/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports